/**
 * Tema seçici panelindeki hazır renkler.
 *
 * Bunlar "güvenli" seçeneklerdir: her biri ensureContrast()'tan geçirilmiş
 * AA-uyumlu güçlü varyantı ile birlikte kullanılır. Kullanıcı özel renk de
 * seçebilir; o durumda güçlü varyant çalışma anında türetilir.
 */

export interface ThemePreset {
  /** Kararlı anahtar — localStorage'da bu saklanır, etiket değil. */
  key: string;
  /** Panelde gösterilen Türkçe ad. */
  label: string;
  hex: string;
}

export const THEME_PRESETS: readonly ThemePreset[] = [
  { key: 'olive', label: 'Zeytin Yeşili', hex: '#8FBD56' },
  { key: 'indigo', label: 'Lacivert', hex: '#4F5BD5' },
  { key: 'ocean', label: 'Okyanus Mavisi', hex: '#2E8BC0' },
  { key: 'teal', label: 'Turkuaz', hex: '#26BF94' },
  { key: 'amber', label: 'Kehribar', hex: '#E8A33D' },
  { key: 'coral', label: 'Mercan', hex: '#F0616D' },
  { key: 'violet', label: 'Mor', hex: '#8B5CF6' },
  { key: 'slate', label: 'Kurşuni', hex: '#5B6B84' },
] as const;

/** Varsayılan tema rengi — referans arayüzün zeytin yeşili. */
export const DEFAULT_PRIMARY_HEX = '#8FBD56';

export function findPresetByHex(hex: string): ThemePreset | undefined {
  const normalized = hex.trim().toLowerCase();
  return THEME_PRESETS.find((p) => p.hex.toLowerCase() === normalized);
}
